import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { useState } from 'react';
import classNames from 'classnames';
import styles from './9442161600c69ea64f17943822d2737a97e1711a4a5ba04c94ecf03588c79ad8.cfe-internal.js';
import { FormFieldProvider } from './f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import HelperText from './7c1b26d854562ce2f8d6b831c64e66b1f3570b813fc6069df25b032c424b76b5.cfe-internal.js';
import ErrorText from './81e9781b77448c920649f3b9c940706a7c107ac8f08d3e5394a7bea4ffd1fed3.cfe-internal.js';
import ReadOnlyText from './b3257a2bcf3225265aab9f27388a0f0cbe2a824975c722d3d4d1fbd254a3af1b.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useIsFocused from '../../hooks/useIsFocused/0f6a89ca013aa6d346e3684cab5faf0ce2a324a0a3a0db4f0f1199945869f4bd.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';

var _excluded = ["children", "className", "errorText", "helperText", "isReadOnly", "id", "data-testid"];
var FormField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    errorText = _ref.errorText,
    helperText = _ref.helperText,
    isReadOnly = _ref.isReadOnly,
    externalId = _ref.id,
    rootDataTestId = _ref['data-testid'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useIsFocused = useIsFocused(),
    _useIsFocused2 = _slicedToArray(_useIsFocused, 2),
    focusRef = _useIsFocused2[0],
    isFocused = _useIsFocused2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasControl = _useState2[0],
    setHasControl = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasLabel = _useState4[0],
    setHasLabel = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formFieldType = _useState6[0],
    setFormFieldType = _useState6[1];
  var containerId = useId(externalId);
  var helperTextId = helperText ? "".concat(containerId, "-helper-text") : undefined;
  var errorTextId = errorText ? "".concat(containerId, "-error-text") : undefined;
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: mergeRefs(ref, focusRef),
    className: classNames(className, _defineProperty({}, styles.formField, hasLabel && hasControl)),
    id: containerId,
    "data-testid": rootDataTestId
  }), /*#__PURE__*/React__default.createElement(FormFieldProvider, {
    value: {
      isFocused: isFocused,
      hasControl: hasControl,
      setHasControl: setHasControl,
      hasLabel: hasLabel,
      setHasLabel: setHasLabel,
      helperTextId: helperTextId,
      errorTextId: errorTextId,
      isReadOnly: isReadOnly,
      setFormFieldType: setFormFieldType
    }
  }, children), helperText || errorText || isReadOnly ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.captionContainer
  }, !helperText && formFieldType === 'input' && isReadOnly && /*#__PURE__*/React__default.createElement(ReadOnlyText, null), helperText && /*#__PURE__*/React__default.createElement(HelperText, {
    id: helperTextId,
    "data-testid": getSubDataTestId(rootDataTestId, 'helper-text')
  }, helperText), errorText && /*#__PURE__*/React__default.createElement(ErrorText, {
    id: errorTextId,
    "data-testid": getSubDataTestId(rootDataTestId, 'error-text')
  }, errorText)) : null);
});

export { FormField as default };
